module.exports = __webpack_public_path__ + "static/media/cef-logo-au.70304e49.svg";